<script>
  import { formatDate } from '@common/utils/dates';

  export let props = {};
  export let row = {};

  $: size = props.size(row);
</script>

{#if size === 'sm'}
  {formatDate(props.timestamp(row), 'M/d/yy h:mma')}
{:else}
  <span class="d-inline d-xl-none">
    {formatDate(props.timestamp(row), 'M/d/yy h:mma')}
  </span>
  <span class="d-none d-xl-inline">
    {formatDate(props.timestamp(row), 'EEE, MMM d, yy @ h:mm a')}
  </span>
{/if}
